import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import keyMirror from 'keymirror';

import Ansi from 'ansi-to-react';
import ScrollableFeed from 'react-scrollable-feed';

import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';
import Dots from '../connection-modal/dots.jsx';

import styles from './compile-progress.css';

const PHASES = keyMirror({
    compiling: null,
    success: null,
    error: null,
    timeout: null
});

const CompileProgressComponent = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={props.name}
        headerClassName={styles.header}
        headerImage={props.connectionSmallIconURL}
        id="connectionModal"
        onHelp={props.onHelp}
        shouldCloseOnOverlayClick={false}
        closeButtonVisible={false}
    >
        <Box className={styles.body}>
            <Box className={styles.terminalWarper}>
                <ScrollableFeed
                    className={styles.terminalText}
                    forceScroll
                >
                    <Ansi>
                        {props.text}
                    </Ansi>
                </ScrollableFeed>
            </Box>
            <Dots
                className={styles.bottomAreaItem}
                counter={0}
                total={3}
            />
            <Box className={styles.bottomArea}>
                <Box className={classNames(styles.bottomAreaItem, styles.instructions)}>
                    {props.phase === PHASES.compiling ? (
                        <FormattedMessage
                            defaultMessage="Compiling"
                            description="Prompt for compile in progress"
                            id="gui.compileProgress.compiling"
                        />
                    ) : null}
                    {props.phase === PHASES.success ? (
                        <FormattedMessage
                            defaultMessage="Compile success"
                            description="Prompt for compile success"
                            id="gui.compileProgress.compileSuccess"
                        />
                    ) : null}
                    {props.phase === PHASES.error ? (
                        <FormattedMessage
                            defaultMessage="Compile error"
                            description="Prompt for compile error"
                            id="gui.compileProgress.compileError"
                        />
                    ) : null}
                    {props.phase === PHASES.timeout ? (
                        <FormattedMessage
                            defaultMessage="Compile timeout"
                            description="Prompt for compile timeout"
                            id="gui.compileProgress.compileTimeout"
                        />
                    ) : null}
                </Box>
                <button
                    className={classNames(styles.bottomAreaItem, styles.connectionButton)}
                    onClick={props.onCancel}
                    disabled={props.phase === PHASES.compiling}
                >
                    <FormattedMessage
                        defaultMessage="Close"
                        description="Button in bottom to close after compile"
                        id="gui.compileProgress.close"
                    />
                </button>
            </Box>
        </Box>
    </Modal>
);

CompileProgressComponent.propTypes = {
    connectionSmallIconURL: PropTypes.string,
    name: PropTypes.node,
    onCancel: PropTypes.func.isRequired,
    onHelp: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    phase: PropTypes.oneOf(Object.keys(PHASES)).isRequired
};

CompileProgressComponent.defaultProps = {
};

export {
    CompileProgressComponent as default,
    PHASES
};
